export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14978.e4e291aa.jpg";